
import { Options, prop, Vue } from "vue-class-component";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { ConfigValidationForm } from "@/domain/entities/CreateBookingV3";
import { flags } from "@/feature-flags";
import Accordion from "@/app/ui/components/accordion/index.vue";
import { CargoController } from "@/app/ui/controllers/CargoController";

class Props {
  modelValue = prop<any>({
    required: true,
  });
  showViewAdjustment = prop<any>({
    default: false,
    type: Boolean,
  });
  defaultOpened = prop<any>({
    default: true,
    type: Boolean,
  });
  title = prop<string>({
    default: "",
    type: String,
  });
  watermark = prop<string>({
    default: "",
    type: String,
  });
  photoGuides = prop<any>({
    default: [
      { source: "guide-photo-one", desc: "Foto timbangan <br /> dengan barang" }
    ]
  });
  configPiece = prop<SttAdjustmentRule>({
    default: new SttAdjustmentRule(),
    type: Object
  });
  marginBottom = prop<boolean>({
    default: true,
    type: Boolean
  });
  showDefault = prop<boolean>({
    default: false,
    type: Boolean
  })
}
@Options({
  emits: ["onUploadImage", "onDeleteImage", "update:showViewAdjustment"],
  components: {
    Accordion,
  },
})
export default class SectionUploadPhotoForWeightAdjusment extends Vue.with(
  Props
) {
  isShaking = false;
  proofPhotos: { source: string; desc: string }[] = [];
  attachmentImage: string[] = [];

  mounted() {
    const defaultPhotos = [
      {
        source: "guide-photo-one",
        desc: "Foto timbangan <br /> dengan barang"
      },
      { source: "guide-photo-two", desc: "Foto ukuran <br /> dengan barang" }
    ];
    const hasDefault = this.modelValue.length && this.showDefault;

    // tampilkan foto dari modelValue jika hasDefault,
    this.proofPhotos = hasDefault
      ? this.modelValue.map((item: string, index: number) => ({
          source: item,
          desc: defaultPhotos[index]?.desc || "Foto tambahan"
        }))
      : [...defaultPhotos];


    this.attachmentImage = hasDefault ? [...this.modelValue] : [""];

    if (this.modelValue.length === 1 && hasDefault) {
      this.proofPhotos.push(defaultPhotos[1]);
      this.attachmentImage.push("");
    }
  }

  get getRulePieceDisabled() {
    return this.configPiece.rule.includes(ConfigValidationForm.NON_EDITABLE);
  }

  get maxPhoto() {
    return flags.flag_max_photo_for_weight_adjustment.getValue();
  }
  onAddImage() {
    this.proofPhotos.push({ source: "", desc: "Foto tambahan" });
    this.attachmentImage.push("");
    this.$emit("update:modelValue", this.attachmentImage);
  }

  onUpload(file: any) {
    this.$emit("update:modelValue", this.attachmentImage);
    if (file.file) this.$emit("onUploadImage", file);
  }

  onRemove(index: number) {
    this.deleteFiles(index);
    this.$emit("onDeleteImage", index);
  }

  deleteFiles(index: number) {
    this.attachmentImage[index] = "";
    this.proofPhotos[index] = {
      source: "",
      desc: this.photoGuides?.[index]?.desc || "Foto tambahan"
    };
    this.$emit("update:modelValue", this.attachmentImage);
  }

  onClickAccordion() {
    const refs: any = this.$refs;
    if (refs && !this.showViewAdjustment) {
      refs["accordion-adjustment"].toggleAccordion();
      const doc: any = document;
      const element = doc.getElementById("section-upload-photo");
      element.scrollIntoView();
      this.isShaking = true;
      setTimeout(() => {
        this.isShaking = false;
      }, 2000);
    }
  }

  onClick(value: any) {
    this.$emit("update:showViewAdjustment", value);
  }

  generateDefaultImage(index: number) {
    const previewImage = this.attachmentImage[index];

    if (!previewImage) return "";
    if (typeof previewImage === "string") return previewImage;
    return URL.createObjectURL(previewImage);
  }

  get dataProfile() {
    return CargoController.dataProfile;
  }

  get customWatermark() {
    return [
      this.$moment(new Date()).format("dddd, DD MMMM YYYY"),
      this.$moment(new Date()).format("HH:mm"),
      `${this.dataProfile.account_location?.city_code} - ${this.dataProfile.account_location?.city_name}`,
      `Uploaded by ${this.dataProfile.username}`
    ];
  }
}
